import { refineContractRequiredMinimum } from "web_myplann/Portfolio/Forms/ContractShared/contractRequiredMinimum";
import {
	getInvestmentBaseShape,
	refineInvestmentDates,
} from "web_myplann/Portfolio/Forms/InvestmentForm/investmentFormSchema";
import { getManualValueShape } from "web_myplann/Portfolio/PortfolioShared/getManualValueShape";
import { refineManualValue } from "web_myplann/Portfolio/PortfolioShared/refineManualValue";
import type { TranslateFunction } from "web_myplann/Shared/TranslateFunction";
import { z } from "zod";

export const getCommoditiesCreateFormSchema = (t: TranslateFunction) =>
	z
		.object({
			...getInvestmentBaseShape(t),
			...getManualValueShape(t),
		})
		.superRefine(refineManualValue(t))
		.superRefine(refineInvestmentDates(t))
		.superRefine(refineContractRequiredMinimum);

export const getCommoditiesEditFormSchema = (t: TranslateFunction) =>
	z
		.object(getInvestmentBaseShape(t))
		.superRefine(refineInvestmentDates(t))
		.superRefine(refineContractRequiredMinimum);

export type CommoditiesCreateFormInput = z.input<
	ReturnType<typeof getCommoditiesCreateFormSchema>
>;
export type CommoditiesCreateFormOutput = z.output<
	ReturnType<typeof getCommoditiesCreateFormSchema>
>;
export type CommoditiesEditFormInput = z.input<
	ReturnType<typeof getCommoditiesEditFormSchema>
>;
export type CommoditiesEditFormOutput = z.output<
	ReturnType<typeof getCommoditiesEditFormSchema>
>;
